import React, { useContext, useCallback, useState } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { JsonView, collapseAllNested, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

import LoadingSpinner from "../Layout/LoadingSpinner";

import { SiteContext } from "../../context/SiteContext";
import { UserContext } from "../../context/UserContext";

const ViewOrder = ({ setInfoModalData }) => {
    const groups = [
        { id: "PZ", name: "PZ" },
        { id: "MercadoLibre", name: "MercadoLibre" },
        { id: "Ripley", name: "Ripley" },
        { id: "paris.cl", name: "Paris" },
        { id: "Dafiti", name: "Dafiti" },
        { id: "FalabellaGlobalProduction", name: "Falabella" },
        { id: "Longtail", name: "Tiendas" },
    ];

    const { env, csrfToken } = useContext(SiteContext);
    const { user } = useContext(UserContext);

    const [formData, setFormData] = useState({ shop: "PZ", idShop: null });
    const [orderLoading, setOrderLoading] = useState(false);
    const [validated, setValidated] = useState(false);

    const handleChange = useCallback((field, value) => {
        setFormData((oldData) => ({
            ...oldData,
            [field]: value,
        }));
    }, []);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        setValidated(true);
        setOrderLoading(false);

        axios
            .get(env.webApiBaseUrl + "/orders/byIdShop/" + formData.shop + "/" + formData.idShop, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "X-CSRF-Token": csrfToken,
                    Authorization: "Bearer " + user.token,
                },
                withCredentials: true,
            })
            .then((orderResponse) => {
                    setInfoModalData({
                        type: "success",
                        msg:
                        <div
                            className="text-start"
                        >
                            <JsonView 
                                data={orderResponse.data} 
                                shouldExpandNode={collapseAllNested} 
                                style={defaultStyles} 
                            />
                        </div>,
                        size: "lg",
                    });
                    setValidated(false);
            })
            .catch((error) => {
                console.log(error);
                setInfoModalData({
                    type: "error",
                    msg: "No pude encontrar la venta. Verifica que el número ingresado sea válido.",
                    size: "sm",
                });
            })
            .finally(() => {
                setOrderLoading(false);
            });
    }, [
        csrfToken,
        env.webApiBaseUrl,
        formData.idShop,
        formData.shop,
        setInfoModalData,
        user.token,
    ]);

    return (
        <Container style={{ height: "8rem" }}>
            <div className="w-100 h-100 p-4 border">
                {orderLoading ? (
                    <LoadingSpinner />
                ) : (
                    <Form
                        className="h-100"
                        validated={validated}
                        onSubmit={(event) => handleSubmit(event)}
                    >
                        <Row>
                            <Col>
                                <Form.Label>Ver detalles de una venta</Form.Label>
                            </Col>
                        </Row>
                        <Row>

                            <Col sm={2}>
                                <Form.Select
                                    id="shop"
                                    className=""
                                    name="shop"
                                    onChange={(event) => handleChange("shop", event.target.value)}
                                >
                                    {groups.map((option) => (
                                        <option
                                            key={"option_" + option.id}
                                            value={option.id}
                                        >
                                            {option.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col sm={8}>
                                <Form.Group className="form-group">
                                    <Form.Control
                                        required
                                        name="idShop"
                                        type="text"
                                        placeholder="Número de venta"
                                        onChange={(event) =>
                                            handleChange("idShop", event.target.value)
                                        }
                                        maxLength={24}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={2}>
                                <Button className="w-100" type="submit" variant="primary">
                                    Ver detalles
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </div>
        </Container>
    );
};

export default ViewOrder;
